$easyreels_user_quota $mol_view
	used_bytes 0
	limit_bytes 0
	sub /
		<= Text $mol_paragraph
			title <= text \
		<= Bar $mol_portion
			portion <= ratio 0
